import * as React from "react";
import { Field } from "formik";
import { LinksField } from "../../../../components/DynamicForm/Elements/forPrint/LinksField";

export const getLinksFieldControl = (props: any) => {
  return <Field component={LinksField} {...props} />;
};
